// Tracciamento conversioni Google Analytics 4.
// Si attiva solo se REACT_APP_GA_ID è impostata in frontend/.env (formato G-XXXXXXXXXX).
// Senza ID configurato, tutto resta inattivo e trackEvent è un no-op.

let initialized = false;

export const trackEvent = (name, params = {}) => {
  if (typeof window.gtag === "function") window.gtag("event", name, params);
};

export const initAnalytics = () => {
  const id = process.env.REACT_APP_GA_ID;
  if (!id || initialized) return;
  initialized = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", id);

  // Click su telefono, WhatsApp ed email: tracciati automaticamente per qualsiasi
  // link tel:, wa.me o mailto: presente o aggiunto in futuro nel sito.
  document.addEventListener("click", (e) => {
    const a = e.target.closest?.("a[href]");
    if (!a) return;
    const href = a.getAttribute("href") || "";
    if (href.startsWith("tel:")) trackEvent("contact_click", { method: "phone" });
    else if (href.includes("wa.me") || href.includes("api.whatsapp.com")) trackEvent("contact_click", { method: "whatsapp" });
    else if (href.startsWith("mailto:")) trackEvent("contact_click", { method: "email" });
  });
};
